import PhotoSwipeGallery from "./PhotoSwipeGallery";
import Overlay from "./Overlay";
import SliderStarter from "./slider/SliderStarter";
import Polyfill from "./Polyfill";

(function(Eventgallery, jQuery){
	"use strict";
    jQuery( document ).ready(function() {

		/*
		* GRID LIST OF EVENTS
		*/

        jQuery('.eventgallery-events-gridlist').each(function(index, container){
        	var $container = jQuery(container);
	    	var $thumbnails = $container.find('.event-thumbnails .event-thumbnail');

	        var options = {
	            rowHeightPercentage: 100,
	            imagesetContainer: $container.find('.event-thumbnails').first(),
	            imageset: $thumbnails,
	            lazyloader: null,
	            initComplete: function () {
	                var lazyLoadOptions = {container: container};
                    options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);
	            },
	            resizeStart: function () {
	                $container.find('.event-thumbnails .event-thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
	            },
	            resizeComplete: function () {
	                options.eventgalleryLazyloader.initialize();
	                jQuery(window).trigger('scroll');
	            }
	        };

	        // initialize the imagelist

	        if ($thumbnails.length>0) {
	        	new Eventgallery.EventsList(options);
	        }
        });


		/*
		* TILE LIST OF EVENTS
		*/

	    jQuery('.eventgallery-events-tiles-list').each(function(index, container){
	    	var $container = jQuery(container);

	        var options = {
	            imagesetContainer: $container.find('.event-thumbnails').first(),
	            imageset: $container.find('.event-thumbnail'),
	            eventgalleryTilesCollection: null,
	            eventgalleryLazyloader: null,
	            initComplete: function () {
	                var lazyLoadOptions = {container: container};
                    options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);

	                var tilesOptions = {
	                    tiles: $container.find('.eventgallery-tiles .eventgallery-tile'),
	                    tilesContainer: $container.find('.eventgallery-tiles')
	                };
	                options.eventgalleryTilesCollection = new Eventgallery.TilesCollection(tilesOptions);
	                options.eventgalleryTilesCollection.calculate();
	                // we need to recalculate the whole thing because it might happen that a font loads
	                // and the size of a tile changes.
	                jQuery(window).load( function(){
	                    options.eventgalleryTilesCollection.calculate();
	                });

	            },
	            resizeStart: function () {
	                $container.find('.event-thumbnails .event-thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
	            },
	            resizeComplete: function () {
	                options.eventgalleryLazyloader.initialize();
	                options.eventgalleryTilesCollection.calculate();
	                jQuery(window).trigger('scroll');
	            }
	        };

	        // initialize the imagelist
	        new Eventgallery.EventsTiles(options);

	    });

		/*
		* TILES LIST OF IMAGES
		*/

	    jQuery('.eventgallery-event-tiles-list').each(function(index, container){
	    	var $container = jQuery(container);
	        var options = {
	            imagesetContainer: $container.find('.event-thumbnails').first(),
	            imageset: $container.find('.event-thumbnail'),
	            adjustMode: 'width',
	            eventgalleryLazyloader: null,
	            eventgalleryTilesCollection: null,
	            initComplete: function () {
	                var lazyLoadOptions = {container: container};
	                var tilesOptions = {
	                    tiles: $container.find('.eventgallery-tiles .eventgallery-tile'),
	                    tilesContainer: $container.find('.eventgallery-tiles')
	                };

                    options.eventgalleryTilesCollection = new Eventgallery.TilesCollection(tilesOptions);
                    options.eventgalleryTilesCollection.calculate();
                    options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);

	                // we need to recalculate the whole thing because it might happen that a font loads
	                // and the size of a tile changes.
	                jQuery(window).load( function(){
	                    options.eventgalleryTilesCollection.calculate();
                        options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);
	                });

	            },
	            resizeStart: function () {
	                $container.find('.event-thumbnails .event-thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
	            },
	            resizeComplete: function () {
	                options.eventgalleryLazyloader.initialize();
	                options.eventgalleryTilesCollection.calculate();
	                jQuery(window).trigger('scroll');
	            }
	        };

	        // initialize the imagelist
	        new Eventgallery.EventsTiles(options);
    	});

		/*
		* SIMPLE IMAGE LIST
		*/
		jQuery('.eventgallery-event-gridlist').each(function(index, container){
			var $container = jQuery(container);
			var options = {
                imagesetContainer: $container.find('.event-thumbnails').first(),
                imageset: $container.find('.event-thumbnail'),
                adjustMode: 'height',
            	eventgalleryLazyloader: null,
                initComplete: function () {
                	var lazyLoadOptions = {container: container};
                    var gridOptions = {
                        tiles: $container.find('.eventgallery-simplelist .eventgallery-simplelist-tile'),
                        tilesContainer: $container.find('.eventgallery-simplelist'),
                        thumbSelector: '.event-thumbnail',
                        thumbContainerSelector: '.event-thumbnails'
                    };

                    options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);
                    // we need to recalculate the whole thing because it might happen that a font loads
                    // and the size of a tile changes.
                    jQuery(window).load( function(){

                        options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);
                    });

                },
                resizeStart: function () {
                    $container.find('.event-thumbnails .event-thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
                },
                resizeComplete: function () {
                    options.eventgalleryLazyloader.initialize();
                    jQuery(window).trigger('scroll');
                }
            };

            // initialize the imagelist
            new Eventgallery.EventsTiles(options);
		});

		/*
		* IMAGE LIST
		*/

        jQuery('.eventgallery-imagelist').each(function(index, imagesetContainer){
			var $imagesetContainer = jQuery(imagesetContainer);
            var options = {
                rowHeight: $imagesetContainer.data('rowheight'),
                rowHeightJitter: $imagesetContainer.data('rowheightjitter'),
                firstImageRowHeight: $imagesetContainer.data('firstimagerowheight'),
                doFillLastRow: $imagesetContainer.data('dofilllastrow') === true,
                imagesetContainer: imagesetContainer,
                imageset: $imagesetContainer.find('.thumbnail'),
                eventgalleryLazyloader: null,

                initComplete: function () {
                	var lazyLoadOptions = {container: imagesetContainer};
                    options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);
                },
                resizeStart: function () {
                    $imagesetContainer.find('.thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
                },
                resizeComplete: function () {
                    options.eventgalleryLazyloader.initialize();
                    jQuery(window).trigger('scroll');
                }
            };

            // initialize the imagelist
            new Eventgallery.Imagelist(options);
        });

		/*
		 * SQUARE SIZED LIST OF IMAGES
		 */

		jQuery('.eventgallery-event-square-list').each(function(index, container){
			var $container = jQuery(container);
			var options = {
				imagesetContainer: $container.find('.event-thumbnails').first(),
				imageset: $container.find('.event-thumbnail'),
				adjustMode: 'width',
				eventgalleryLazyloader: null,
				initComplete: function () {
					var lazyLoadOptions = {container: container};
					options.eventgalleryLazyloader = new Eventgallery.Lazyload(lazyLoadOptions);

				},
				resizeStart: function () {
					$container.find('.event-thumbnails .event-thumbnail img.eventgallery-lazyme').removeClass('eventgallery-lazyload-loaded').addClass('eventgallery-lazyload-loading');
				},
				resizeComplete: function () {
					options.eventgalleryLazyloader.initialize();
					jQuery(window).trigger('scroll');
				}
			};

			// initialize the imagelist
			new Eventgallery.SquareList(options);
		});


		/**
		 * sets the radio button if one clicks in a table row.
		 */
		jQuery('.eventgallery-imagetype-selection-row').click(function(e){
			var $target = jQuery(e.target);
			$target.closest('tr').find('input').prop("checked", true);
		});

		jQuery( document ).on('touchend click', '.eventgallery-cart-connector', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var link = jQuery(e.target);

			if (!link.attr('data-href')) {
				link = link.parent('SPAN');
			}

			window.location.href = link.attr('data-href');
		});

        /**
		 * Lightbox init
         * @type {PhotoSwipeGallery}
         */
        Eventgallery.lightbox = new PhotoSwipeGallery();
        Eventgallery.lightbox.initPhotoSwipe();

        /**
		 * Single Image Page
         */
        jQuery('.singleimage-zoom').click(function(e){
            e.preventDefault();
            jQuery('#bigimagelink').click();
        });

        /**
		 * content overlay
         */
        jQuery('a[data-eventgallery-overlay]').each(function(item){
        	let contentId = this.getAttribute('href');
        	jQuery(this).click(function(e){
                let overlay = new Overlay();

                overlay.openOverlay(document.getElementById(contentId.replace("#","")).innerHTML);
            })
        });

        if (window.EventGalleryLightboxConfiguration && window.EventGalleryLightboxConfiguration.doPreventRightClick) {
            jQuery(document).on("contextmenu", 'a[data-eg-lightbox] img, img.pswp__img', function(){
                return false;
            });
        }

        let googlePhotosProcessor = new Eventgallery.GooglePhotosProcessor();
        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-images-added'));


        let sliderElements = document.querySelectorAll('div[data-slider="1"]');


        for(let i=0; i<sliderElements.length; i++) {
            let sliderStarter = new SliderStarter(sliderElements[i]);
            let timer = null;
            sliderStarter.start();

            window.addEventListener("resize", () => {
            	if (timer != null) {
            		clearTimeout(timer);
				}
            	timer = setTimeout(() => sliderStarter.start(), 1000);
            }, false);
        }



    }); //end domready
})(Eventgallery, Eventgallery.jQuery);

